import { render, staticRenderFns } from "./HeaderCategoriesDropdownCategory.vue?vue&type=template&id=1d166e50&"
import script from "./HeaderCategoriesDropdownCategory.vue?vue&type=script&lang=js&"
export * from "./HeaderCategoriesDropdownCategory.vue?vue&type=script&lang=js&"
import style0 from "./HeaderCategoriesDropdownCategory.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports